import {
    SET_CURRENT_POST,
    SET_IS_BUBBLE_OPEN,
    SET_USER_COMPLETED_EVENT_TASKS,
    SET_TOTAL_EVENT_TASKS,
    SET_EVENT_TASKS,
    SET_IS_PROGRAM_TEEM,
    SET_TOTAL_EVENT_TASKS_LOADING
} from "../actions/contentActions";


export interface ContentReducerState {
    currentPost: any,
    isBubbleOpen: boolean,
    totalEventTasks: number,
    isTotalEventTasksLoading: boolean,
    isProgramTeam: boolean,
    userCompletedEventTasks: number,
    eventTasks: any,
}

const initialState: ContentReducerState = {
    currentPost: null,
    isBubbleOpen: false,
    totalEventTasks: 0,
    isProgramTeam: false,
    userCompletedEventTasks: 0,
    eventTasks: null,
    isTotalEventTasksLoading: true
}

export const contentReducer = (state = initialState, action: any) => {
    switch (action.type) {

        case SET_EVENT_TASKS:
            return {
                ...state,
                eventTasks: action.value
            }
        case SET_USER_COMPLETED_EVENT_TASKS:
            return {
                ...state,
                userCompletedEventTasks: action.value
            }
        case SET_TOTAL_EVENT_TASKS:
            return {
                ...state,
                totalEventTasks: action.value
            }
        case SET_TOTAL_EVENT_TASKS_LOADING:
            return {
                ...state,
                isTotalEventTasksLoading: action.value
            }
        case SET_IS_PROGRAM_TEEM:
            return {
                ...state,
                isProgramTeam: action.value
            }
        case SET_CURRENT_POST:
            return {
                ...state,
                currentPost: action.value
            }
        case SET_IS_BUBBLE_OPEN:
            return {
                ...state,
                isBubbleOpen: action.value
            }
        default:
            return state;
    }
}

